export function getCookie(name) {
  if (!document.cookie) return null;
  const cookies = document.cookie.split(";");

  for (const cookie of cookies) {
    const [key, value] = cookie.trim().split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}

export function authHeaders(extra = {}) {
  const csrftoken = getCookie("csrftoken");

  return {
    "Content-Type": "application/json",
    ...(csrftoken ? { "X-CSRFToken": csrftoken } : {}),
    ...extra,
  };
}
